import { compact } from 'lodash-es';
import { isClientTaxExempt } from '~/models/ClientModel';
import { filterClients, sortClients } from './ClientsPage.utils';
export const CLIENT_COLUMN_NAMES = [
    'clientName',
    'status',
    'type',
    'contacts',
    'tax'
];
const statusSkinByLabel = (statusTexts)=>({
        [statusTexts.active()]: 'success',
        [statusTexts.archived()]: 'default'
    });
const statusLabel = (client, statusTexts)=>client.status == null ? '' : statusTexts[client.status]();
const contactsLabel = (client, texts)=>{
    var _client_contactsCount;
    if (client.primaryContact == null) return '';
    const remainingCount = ((_client_contactsCount = client.contactsCount) !== null && _client_contactsCount !== void 0 ? _client_contactsCount : 0) - 1;
    const more = remainingCount > 0 ? texts.contactsMore({
        count: remainingCount
    }) : '';
    return "".concat(client.primaryContact.name).concat(more);
};
const taxLabel = (client, texts)=>isClientTaxExempt(client.taxSettings) ? texts.tax.exempt() : texts.tax.taxable();
export const toClientRows = (param)=>{
    let { clients, texts, statusTexts } = param;
    return clients.map((client)=>{
        var _client_type, _ref;
        var _client_primaryContact;
        return {
            id: client.id,
            clientName: client.name,
            status: statusLabel(client, statusTexts),
            type: texts.typeFilter[(_client_type = client.type) !== null && _client_type !== void 0 ? _client_type : 'business'](),
            contacts: contactsLabel(client, texts),
            contactEmail: (_ref = (_client_primaryContact = client.primaryContact) === null || _client_primaryContact === void 0 ? void 0 : _client_primaryContact.email) !== null && _ref !== void 0 ? _ref : '',
            tax: taxLabel(client, texts)
        };
    });
};
const taxColumn = (texts)=>({
        type: 'text',
        name: 'tax',
        header: texts.columnHeaders.tax(),
        width: {
            initial: 160,
            min: 120
        },
        sortable: true,
        bi: {
            name: 'clients_by_tax'
        }
    });
export const clientColumns = (param)=>{
    let { texts, statusTexts, showTax } = param;
    return [
        {
            type: 'text',
            name: 'clientName',
            header: texts.columnHeaders.clientName(),
            width: {
                initial: 170,
                min: 170
            },
            weight: 'normal',
            sortable: true,
            bi: {
                name: 'clients_by_name'
            }
        },
        {
            type: 'badge',
            name: 'status',
            header: texts.columnHeaders.status(),
            width: {
                initial: 100,
                min: 100
            },
            useColor: (label)=>{
                var _statusSkinByLabel_label;
                return (_statusSkinByLabel_label = statusSkinByLabel(statusTexts)[label]) !== null && _statusSkinByLabel_label !== void 0 ? _statusSkinByLabel_label : 'default';
            },
            sortable: true,
            bi: {
                name: 'clients_by_status'
            }
        },
        {
            type: 'text',
            name: 'type',
            header: texts.columnHeaders.type(),
            width: {
                initial: 120,
                min: 120
            },
            sortable: true,
            bi: {
                name: 'clients_by_type'
            }
        },
        {
            type: 'text',
            name: 'contacts',
            header: texts.columnHeaders.contacts(),
            width: {
                initial: 220,
                min: 220
            },
            subtitle: (row)=>[
                    row.contactEmail
                ],
            sortable: true,
            bi: {
                name: 'clients_by_contacts'
            }
        },
        ...compact([
            showTax && taxColumn(texts)
        ])
    ];
};
export const visibleClients = (param)=>{
    let { clients, search, statusFilter, typeFilter, sort } = param;
    return sortClients({
        clients: filterClients({
            clients,
            searchTerm: search,
            statusFilter,
            typeFilter
        }),
        sortKey: sort.name,
        sortDirection: sort.direction === 'asc' ? 'desc' : 'asc'
    });
};
